module.exports = new __parcel__URL__("brickouest.73c248cd.webp").toString();